import $ from 'jquery';

import { currentForm, formKey, formOptionList, getFormInputList, formInputStatusList } from "./form-data";
import { validateInput, validateInputList } from "./form-validation";

export const formValidationEvents = () => {
	const formInputList = getFormInputList() ;

	console.log("Reinitating validation event",formInputList);
  $(currentForm).attr('novalidate', 'novalidate');

  formOptionList.change(function(event) {
    const thisInput =$( event.target );
    validateInput(formKey, thisInput);
  })



  $(formInputList).blur(function(event) {
  	//console.log("Blur triggered",event);
    const thisInput =$( event.target );
    validateInput(formKey, thisInput);
  })

	$(currentForm).submit(function( event ) {
		validateInputList(formKey, formInputList);

    const submitBtn = $(this).find('.js-submitButton');

    if (formInputStatusList().length > 0) {
      submitBtn.attr('disabled','false');
      submitBtn.removeAttr('disabled');
      event.preventDefault();
    }
    else {
      submitBtn.attr('disabled','true');
    }

    // enalbeSubmitBtn(submitBtn);

    // const enalbeSubmitBtn = () => {
    //   console.log("button");
    //   submitBtn.removeAttr('disabled');
    // }

    // setTimeout(enalbeSubmitBtn, 3000);

	});
}



